import { IRootState } from '../../../store'
import { IBloodProductAdministrationOptionsState } from '../store/options.types'

export const getBloodProductAdministrationOptionsSelector = (
  state: IRootState
): IBloodProductAdministrationOptionsState => state.options.bloodProductAdministrationOptions
